import React from 'react'
import { Grid, Typography, Button } from '@mui/material'
import { logout } from '../../actions/auth'
import { useDispatch } from 'react-redux'
import styled from  '@emotion/styled'

const HeaderContainer = styled(Grid)({
  padding: '1.5em 4em'
})

const StyledButton = styled(Button)({
  color: 'black'
})

const AdminLoggedInNav = ({ user }) => {
  const dispatch = useDispatch()

  const handleLogOut = () => {
    dispatch(logout())
  }

  return (
    <HeaderContainer container alignItems='center' justifyContent='space-between'>
      <Grid item>
        <Typography variant='h6'>{user.name}</Typography>
      </Grid>

      <Grid item>
        <Grid container spacing={3}>
          <Grid item>
            <StyledButton onClick={handleLogOut}>Thoát</StyledButton>
          </Grid>
        </Grid>
      </Grid>
    </HeaderContainer>
  );
}

export default AdminLoggedInNav
